<template>
    <div>
        <el-select
            v-model="form.value"
            :name="form.name"
            filterable
            :disabled="form.attr && form.attr.disabled ? true : false"
            :placeholder="form.placeholder"
            :size="form.attr && form.attr.size ? form.attr.size : ''"
            :multiple="form.attr && form.attr.multiple ? true : false"
            :fit-input-width="form.attr && form.attr.fitinputwidth ? true : false"
            :placement="form.attr && form.attr.placement ? form.attr.placement : ''"
            remote
            reserve-keyword
            remote-show-suffix
            :remote-method="selectAjaxFunction"
            :loading="selectAjaxLoading">
            <template v-for="(item, index) in options" :key="index">
                <template v-if="typeof(item) == 'string'">
                    <el-option
                        :label="item"
                        :key="index"
                        :value="index"
                        :disabled="item.indexOf('disabled:') > -1">
                        <text v-if="item.indexOf('disabled:') > -1">{{ item.slice(9) }}</text>
                        <text v-else>{{ item }}</text>
                    </el-option>
                </template>
                <template v-else>
                    <el-option
                        :label="item[form.config.key]"
                        :value="item[form.config.value]"
                        :key="item[form.config.value]"
                        :disabled="item.disabled">
                        <text v-if="item.title_display" v-html="item.title_display" />
                        <text v-else>{{ item[form.config.key] }}</text>
                    </el-option>
                </template>
            </template>
        </el-select>
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, inject, watch } from 'vue'
    import { selectAjaxRemoteMethod } from '@/utils/function'
    export default defineComponent({
        props: {
            formobj: {
                type: [Array, Object],
                default: () => {}
            }
        },
        setup(props, context) {
            const form = ref(props.formobj)
            const options = ref(form.value.options)
            const { proxy } = getCurrentInstance()
            const selectAjaxLoading = ref(false)
            const selectAjaxFunction = (query, value = false) => {
                selectAjaxLoading.value = true
                let url = form.value.attr.url
                if (!url) {
                    url = form.value.attr.params
                }

                if (value !== false) {
                    url.value = JSON.stringify(value)
                }
                selectAjaxRemoteMethod(query, url, proxy).then((e) => {
                    options.value = e
                    selectAjaxLoading.value = false
                }).catch((error) => {
                    proxy.jiu.showError(error)
                    selectAjaxLoading.value = false
                })
            }
            if (
                (Object.prototype.toString.call(form.value.value) === '[object Array]' && form.value.value.length > 0) ||
                (Object.prototype.toString.call(form.value.value) === '[object String]' && form.value.value.length > 0) ||
                (Object.prototype.toString.call(form.value.value) === '[object Number]' && form.value.value > 0)
            ) {
                selectAjaxFunction('', form.value.value)
            }
            return {
                form,
                selectAjaxLoading,
                selectAjaxFunction,
                options
            }
        }
    })
</script>

<style scoped>

</style>
